import axios from "axios";

import { weatherAppAPI } from "../helpers/API";
import { myToast } from "../helpers/extraFunctions";
import { setItem } from "../helpers/sessionStorage";
import { GET_DATA_ERROR, GET_DATA_LOADING, GET_DATA_SUCCESS } from "./actionTypes";






export const getDataLoading = () => {
    return { type: GET_DATA_LOADING };
}

export const getDataSuccess = (payload) => {
    return { type: GET_DATA_SUCCESS, payload };
}

export const getDataError = () => {
    return { type: GET_DATA_ERROR };
}


export const getWeatherByLocation = (toast, lang, t) => (dispatch) => {
    const success = async (position) => {
        try {
            let { latitude, longitude } = position.coords;
            dispatch(getDataLoading());
            let weatherData = await axios.get(`/weather?lat=${latitude}&lon=${longitude}&appid=${weatherAppAPI}&lang=${lang}`);
            weatherData = weatherData.data;
            let forcastData = await axios.get(`/onecall?lat=${latitude}&lon=${longitude}&exclude=hourly,minutely&units=metric&appid=${weatherAppAPI}&lang=${lang}`);
            forcastData = forcastData.data.daily;
            let payload = { weatherData, forcastData }
            dispatch(getDataSuccess(payload));
            setItem("weather", payload);
            myToast(toast, t("Konumunuzdaki hava durumu yüklendi"))
        } catch (err) {
            console.log(err);
            dispatch(getDataError());
        }
    }
    
    const error = (err) => {
        console.warn(`ERROR(${err.code}): ${err.message}`);
        myToast(toast, t("Lütfen konum bilgisini açınız"))
    }
    
    navigator.geolocation.getCurrentPosition(success, error);
}

export const getWeatherByCity = (city, toast, lang, t) => async (dispatch) => {
    try {
        dispatch(getDataLoading());
        let weatherData = await axios.get(`/weather?q=${city}&appid=${weatherAppAPI}&lang=${lang}`);
        weatherData = weatherData.data;
        let { lon, lat } = weatherData.coord;
        let forcastData = await axios.get(`/onecall?lat=${lat}&lon=${lon}&exclude=hourly,minutely&units=metric&appid=${weatherAppAPI}&lang=${lang}`);
        forcastData = forcastData.data.daily;
        let payload = { weatherData, forcastData };
        dispatch(getDataSuccess(payload));
        setItem("weather", payload);
        myToast(toast, t("Bilgiler Güncellendi"));

    } catch (err) {
        console.log(err);
        dispatch(getDataError());
        myToast(toast, t("Hata , Şehir Bulunamadı"));
    }
}

export const syncData = (city, toast, lang, t) => async (dispatch) => {

    try {
        let weatherData = await axios.get(`/weather?q=${city}&lang=${lang}&appid=${weatherAppAPI}`);
        weatherData = weatherData.data;
        let { lon, lat } = weatherData.coord;
        let forcastData = await axios.get(`/onecall?lat=${lat}&lon=${lon}&lang=${lang}&exclude=hourly,minutely&units=metric&appid=${weatherAppAPI}`);
        forcastData = forcastData.data.daily;
        let payload = { weatherData, forcastData };
        dispatch(getDataSuccess(payload));
        setItem("weather", payload);
        myToast(toast, t("Bilgiler Güncellendi"));
    } catch (err) {
        console.log(err);
        dispatch(getDataError());
        myToast(toast, t("Hata, Şehir Bulunamadı"));
    }
}

